export default Object.freeze({
  USER: "USER",
  PAYMENT: "PAYMENT",
  AGENCY: "AGENCY",
});
